<div class="logout__wrapper">
    <section class="logout">
        <h1>Session expirée</h1>
        <h2>Veuillez vous authentifier de nouveau</h2>
        <button pButton type="button" label="Connexion" icon="appicons ic-sign-in-alt" (click)="redirect()"></button>
    </section>
</div>